import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/public/Header";
import Hero from "@/components/public/Hero";
import Marquee from "@/components/public/Marquee";
import QuickLinks from "@/components/public/QuickLinks";
import Gallery from "@/components/public/Gallery";
import About from "@/components/public/About";
import Testimonials from "@/components/public/Testimonials";
import LatestPhotos from "@/components/public/LatestPhotos";
import Footer from "@/components/public/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-blush text-plum font-sans overflow-x-clip" data-testid="landing-page">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-0 opacity-25 mix-blend-multiply bg-cover bg-top"
        style={{ backgroundImage: "url(/brand/watercolour.jpg)" }}
      />
      <Header />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <QuickLinks />
        <Testimonials />
        <Gallery />
        <About />
        <LatestPhotos />
      </main>
      <Footer />
    </div>
  );
}
